import type { LogEntry } from "./hooks";

const toneClass: Record<LogEntry["tone"], string> = {
  good: "text-ok",
  bad: "text-danger",
  info: "text-ink",
  neutral: "text-ink-2",
};

/** The last few log entries for the middle of the board. Older lines fade out. */
export function CompactLog({ entries, count = 6 }: { entries: LogEntry[]; count?: number }) {
  const shown = entries.slice(-count);
  return (
    <ol className="flex h-full w-full flex-col justify-end gap-0.5 overflow-hidden text-left text-[11px] leading-tight sm:text-xs" aria-label="Letzte Ereignisse">
      {shown.map((e, i) => (
        <li
          key={e.id}
          className={`${toneClass[e.tone]} ${e.involvesSelf ? "font-semibold" : ""}`}
          style={{ opacity: 0.7 + (0.3 * (i + 1)) / shown.length }}
        >
          {e.text}
        </li>
      ))}
    </ol>
  );
}
